import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_5402ufjv6k: FaireBrandEntity = {
  token: "b_5402ufjv6k",
  type: "brand",
  name: "UpCircle USA",
  avatarUrl:
    "https://cdn.faire.com/fastly/93ef1fc2ab820dbb25ba9dbb6b6e119dee73cd10bfb7ff5402be621b8633d596.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/039a6af644b564521492665095b2694a924664b3d7c77e9cf714fc2b683d1950.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/93ef1fc2ab820dbb25ba9dbb6b6e119dee73cd10bfb7ff5402be621b8633d596.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/039a6af644b564521492665095b2694a924664b3d7c77e9cf714fc2b683d1950.jpeg",
  location: "NJ, USA",
  minimumOrderDollars: 100,
  rating: 5,
  reviewCount: 129,
  isTopShop: true,
  isInsider: true,
  description:
    "Nature gives us lots of wonderful ingredients that make our skin healthier and more radiant – like used coffee grounds, fruit stones and brewed chai spices. But they often end up going to landfill. Why should all that good stuff go to waste?\n\nIt shouldn’t. That’s why, at UpCircle, we upcycle natural by-product ingredients, bringing them back to life as beauty products your skin will love. Natural skincare, haircare & bodycare made by hand in the UK & US.\n\nIf you would like to receive free samples before you order please send us a message as we'd be happy to arrange. \n\nThis is our US page, with orders shipping from New Jersey. \nInternational customers see below:\nFaire UK (shipping from UK) --> www.faire.com/brand/b_d8pw26ram7\nFaire Europe (shipping from NL) --> www.faire.com/brand/b_p95g7pj4y5",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:29.120Z",
    importedBy: "entity-db-cli",
  },
};
